import { QSetStatusTag } from '@exam-management/components';
import type { QSet } from '@exam-management/graphql';
import { EllipsisText, type GridColDef, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

interface PublishedQSetColumn {
  id: QSet['id'];
  code: QSet['code'];
  status: QSet['status'];
  lastPublishedAt: QSet['lastPublishedAt'];
  qConfig: {
    code: QSet['qConfig']['code'];
    name: QSet['qConfig']['name'];
  };
}

export const columns: GridColDef<PublishedQSetColumn>[] = [
  {
    field: 'code',
    headerName: 'QSet ID',
    sortable: false,
    width: 140,
    renderCell: (params) => {
      return <Text>{params.row.code}</Text>;
    },
  },
  {
    field: 'qConfig.name',
    headerName: 'QConfig Name',
    sortable: false,
    flex: 1,
    minWidth: 192,
    renderCell: (params) => {
      return <EllipsisText maxLines={1}>{params.row.qConfig.name}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.code',
    headerName: 'QConfig ID',
    sortable: false,
    flex: 1,
    minWidth: 192,
    renderCell: (params) => {
      return <Text>{params.row.qConfig.code}</Text>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    flex: 1,
    minWidth: 160,
    renderCell: (params) => {
      return <QSetStatusTag status={params.row.status} size='large' />;
    },
  },
  {
    field: 'lastPublishedAt',
    headerName: 'Published at',
    flex: 1,
    minWidth: 180,
    renderCell: (params) => {
      return <>{params.row.lastPublishedAt ? formatDateTime(params.row.lastPublishedAt) : '-'}</>;
    },
  },
];
